// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__2F2EY","head":"ProcedureTableInfo_head__3Fi6o"};